import useTypedContext from "hooks/useTypedContext";
import Stepper from "ds/components/Stepper";
import StepperStep from "ds/components/Stepper/Step";
import StepperStepsGroup from "ds/components/Stepper/StepsGroup";
import StepperHeader from "ds/components/Stepper/Header";

import { StackFormContext } from "../context";
import { stackCreationWizardNavSummaryStep } from "../constants";
import { isStepRequired } from "../utils";
import { useNewStackAnalyticsSegmentEvent } from "../useNewStackAnalyticsSegmentEvent";
import { StackCreationWizardStep } from "../types";
import styles from "./styles.module.css";

const NewStackStepper = () => {
  const trackSegmentEvent = useNewStackAnalyticsSegmentEvent();

  const {
    availableSteps,
    currentStep,
    currentStepIndex,
    setCurrentStep,
    formData,
    stepperNavDisabled,
    isIntermediateStepActive,
    setIsIntermediateStepActive,
  } = useTypedContext(StackFormContext);

  const setStep = (step: StackCreationWizardStep) => {
    if (isIntermediateStepActive) {
      setIsIntermediateStepActive(false);
    }

    setCurrentStep(step);
    trackSegmentEvent("Step click", {
      currentStep,
      newStep: step,
    });
  };

  return (
    <Stepper className={styles.stepper}>
      <StepperHeader>Follow the steps</StepperHeader>
      <StepperStepsGroup>
        {[...availableSteps, stackCreationWizardNavSummaryStep].map((item, index) => (
          <StepperStep
            disabled={stepperNavDisabled || index > currentStepIndex}
            key={item.step}
            active={item.step === currentStep}
            onClick={index < currentStepIndex ? () => setStep(item.step) : undefined}
          >
            {item.name}
            {item.isOptional && !isStepRequired(item.step, formData) && " (optional)"}
          </StepperStep>
        ))}
      </StepperStepsGroup>
    </Stepper>
  );
};

export default NewStackStepper;
